import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=7815a78a&scoped=true&"
import script from "./UserFeedback.vue?vue&type=script&lang=js&"
export * from "./UserFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815a78a",
  null
  
)

component.options.__file = "UserFeedback.vue"
export default component.exports